//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ApiResult } from '../nswag/nswag-base-class';
import { NSwagBaseClassDataHub } from '../nswag/nswag-base-class-datahub';
import { NSwagBaseClassDataService } from '../nswag/nswag-base-class-dataservice';

export class CertificateService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return OK
     */
    getAll(): Promise<ApiResult<CertificateDto[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateUpdateCertificateDto | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Certificates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    update(body: CreateUpdateCertificateDto | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Certificates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("PUT", url_, options_);
    }

        /**
     * @return OK
     */
    get(certificateId: string): Promise<ApiResult<CertificateDto>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    delete(certificateId: string): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.process("DELETE", url_, options_);
    }
}

export class ConnectionService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @param dataSourceId (optional) 
     * @return OK
     */
    add(dataSourceId: string | undefined): Promise<ApiResult<ConnectionDto>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Connections/add?";
        if (dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' cannot be null.");
        else if (dataSourceId !== undefined)
            url_ += "dataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param correlationId (optional) 
     * @return OK
     */
    getAll(correlationId: string | undefined): Promise<ApiResult<ConnectionListModel[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Connections?";
        if (correlationId === null)
            throw new Error("The parameter 'correlationId' cannot be null.");
        else if (correlationId !== undefined)
            url_ += "correlationId=" + encodeURIComponent("" + correlationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    save(body: ConnectionDto | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Connections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return OK
     */
    get(connectionId: string): Promise<ApiResult<ConnectionDto>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Connections/{connectionId}";
        if (connectionId === undefined || connectionId === null)
            throw new Error("The parameter 'connectionId' must be defined.");
        url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    delete(connectionId: string): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Connections/{connectionId}";
        if (connectionId === undefined || connectionId === null)
            throw new Error("The parameter 'connectionId' must be defined.");
        url_ = url_.replace("{connectionId}", encodeURIComponent("" + connectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.process("DELETE", url_, options_);
    }
}

export class DataProviderService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return OK
     */
    getAll(): Promise<ApiResult<DataProviderDomain[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    create(body: DataProviderDomain | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DataProviderDomain | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("PUT", url_, options_);
    }

        /**
     * @return OK
     */
    get(dataProviderId: string): Promise<ApiResult<DataProviderDomain>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataProviders/{dataProviderId}";
        if (dataProviderId === undefined || dataProviderId === null)
            throw new Error("The parameter 'dataProviderId' must be defined.");
        url_ = url_.replace("{dataProviderId}", encodeURIComponent("" + dataProviderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    delete(dataProviderId: string): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataProviders/{dataProviderId}";
        if (dataProviderId === undefined || dataProviderId === null)
            throw new Error("The parameter 'dataProviderId' must be defined.");
        url_ = url_.replace("{dataProviderId}", encodeURIComponent("" + dataProviderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.process("DELETE", url_, options_);
    }

        /**
     * @return OK
     */
    getDataProviderCertificates(dataProviderId: string): Promise<ApiResult<CertificateDto[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataProviders/{dataProviderId}/certificates";
        if (dataProviderId === undefined || dataProviderId === null)
            throw new Error("The parameter 'dataProviderId' must be defined.");
        url_ = url_.replace("{dataProviderId}", encodeURIComponent("" + dataProviderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    getDataSourcesByDataProviderId(dataProviderId: string): Promise<ApiResult<DataSourceListModel[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataProviders/{dataProviderId}/datasources";
        if (dataProviderId === undefined || dataProviderId === null)
            throw new Error("The parameter 'dataProviderId' must be defined.");
        url_ = url_.replace("{dataProviderId}", encodeURIComponent("" + dataProviderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }
}

export class DataSourceService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return OK
     */
    getHistory(dataSourceId: string): Promise<ApiResult<DataSourceListModel[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/{dataSourceId}/history";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param dataProviderId (optional) 
     * @return OK
     */
    add(dataProviderId: string | undefined): Promise<ApiResult<DataSourceDto>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/add?";
        if (dataProviderId === null)
            throw new Error("The parameter 'dataProviderId' cannot be null.");
        else if (dataProviderId !== undefined)
            url_ += "dataProviderId=" + encodeURIComponent("" + dataProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    get(dataSourceId: string): Promise<ApiResult<DataSourceDto>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/{dataSourceId}";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    delete(dataSourceId: string): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/{dataSourceId}";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.process("DELETE", url_, options_);
    }

        /**
     * @return OK
     */
    getDataSourceResponses(dataSourceId: string): Promise<ApiResult<DataSourceResponseEntity[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/{dataSourceId}/responses";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    getExpressions(dataSourceId: string): Promise<ApiResult<ExpressionListModel[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/{dataSourceId}/expressions";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    createAsync(body: DataSourceDto | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    updateAsync(body: DataSourceDto | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("PUT", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    export(body: string[] | undefined): Promise<ApiResult<ExportDataSourcesDto>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    import(body: ExportDataSourcesDto | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSources/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("POST", url_, options_);
    }
}

export class DataSourceResponseService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return OK
     */
    get(dataSourceResponseId: string): Promise<ApiResult<DataSourceResponseEntity>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSourceResponses/{dataSourceResponseId}";
        if (dataSourceResponseId === undefined || dataSourceResponseId === null)
            throw new Error("The parameter 'dataSourceResponseId' must be defined.");
        url_ = url_.replace("{dataSourceResponseId}", encodeURIComponent("" + dataSourceResponseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    save(body: DataSourceResponseDomain | undefined): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/DataSourceResponses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("POST", url_, options_);
    }
}

export class ExpressionService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return OK
     */
    getHistory(expressionCorrelationId: string): Promise<ApiResult<ExpressionListModel[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Expressions/{expressionCorrelationId}/history";
        if (expressionCorrelationId === undefined || expressionCorrelationId === null)
            throw new Error("The parameter 'expressionCorrelationId' must be defined.");
        url_ = url_.replace("{expressionCorrelationId}", encodeURIComponent("" + expressionCorrelationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    get(expressionId: string): Promise<ApiResult<ExpressionDomain>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Expressions/{expressionId}";
        if (expressionId === undefined || expressionId === null)
            throw new Error("The parameter 'expressionId' must be defined.");
        url_ = url_.replace("{expressionId}", encodeURIComponent("" + expressionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    delete(expressionId: string): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Expressions/{expressionId}";
        if (expressionId === undefined || expressionId === null)
            throw new Error("The parameter 'expressionId' must be defined.");
        url_ = url_.replace("{expressionId}", encodeURIComponent("" + expressionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.process("DELETE", url_, options_);
    }

        /**
     * @return OK
     */
    create(body: ExpressionDomain): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Expressions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return OK
     */
    update(body: ExpressionDomain): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Expressions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.process("PUT", url_, options_);
    }

        /**
     * @return OK
     */
    apply(body: ApplyExpressionModel): Promise<ApiResult<ExpressionsResult>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Expressions/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return OK
     */
    copyToDataSources(expressionId: string, dataSourcesId: string[]): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Expressions/{expressionId}/copy-to-datasources?";
        if (expressionId === undefined || expressionId === null)
            throw new Error("The parameter 'expressionId' must be defined.");
        url_ = url_.replace("{expressionId}", encodeURIComponent("" + expressionId));
        if (dataSourcesId === undefined || dataSourcesId === null)
            throw new Error("The parameter 'dataSourcesId' must be defined and cannot be null.");
        else
            dataSourcesId && dataSourcesId.forEach(item => { url_ += "dataSourcesId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.process("POST", url_, options_);
    }
}

export class InvokeService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    callWithModel(body: InvokeDataSourceModel | undefined): Promise<ApiResult<DataHubResult>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Invoke/call";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    callWithNames(dataProviderName: string, dataSourceName: string, body: InvokeDataSourceModel | undefined): Promise<ApiResult<DataHubResult>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Invoke/call/{dataProviderName}/{dataSourceName}";
        if (dataProviderName === undefined || dataProviderName === null)
            throw new Error("The parameter 'dataProviderName' must be defined.");
        url_ = url_.replace("{dataProviderName}", encodeURIComponent("" + dataProviderName));
        if (dataSourceName === undefined || dataSourceName === null)
            throw new Error("The parameter 'dataSourceName' must be defined.");
        url_ = url_.replace("{dataSourceName}", encodeURIComponent("" + dataSourceName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @param body (optional) 
     * @return OK
     */
    callWithDataSourceId(dataSourceId: string, body: InvokeDataSourceModel | undefined): Promise<ApiResult<DataHubResult>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Invoke/call/{dataSourceId}";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return OK
     */
    getInvocationDetails(storageReferenceString: string): Promise<ApiResult<InvocationDetail>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Invoke/details?";
        if (storageReferenceString === undefined || storageReferenceString === null)
            throw new Error("The parameter 'storageReferenceString' must be defined and cannot be null.");
        else
            url_ += "storageReferenceString=" + encodeURIComponent("" + storageReferenceString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }
}

export class TenantService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return OK
     */
    dataSources(tenantId: string): Promise<ApiResult<DataProviderDataSourcesDto[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Tenants/{tenantId}/datasources";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }
}

export class UserService extends NSwagBaseClassDataHub {
    private readonly baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return OK
     */
    canModifyData(): Promise<ApiResult<CanModifyDataDto>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Users/canModifyData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return OK
     */
    tenants(): Promise<ApiResult<TenantDto[]>> {
        let url_ = this.baseUrl + "/api/v1/datahub/Users/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }
}

export enum AggregationMethod {
    First = 0,
    Sequence = 1,
    Sum = 2,
    Count = 3,
    Avg = 4,
    Min = 5,
    Max = 6,
    Last = 7,
}

export interface CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    isCustomTemplate: boolean;
    items: CredentialItemDto[] | null;
}

export interface ApikeyCredentialsDto extends CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    headerName: string | null;
    key: string | null;
    schema: string | null;
}

export interface ApplyExpressionModel {
    response: string | null;
    dataSourceId: string;
}

export enum AuthenticationMethod {
    None = 0,
    BasicAuth = 1,
    ApiKey = 2,
    Certificate = 3,
    BearerToken = 4,
    CustomTemplate = 5,
    CustomToken = 6,
    InfologAuth = 7,
    CookieAuth = 8,
    Msal = 9,
}

export interface BaseEntity {
    id: string;
    readonly isNew: boolean;
}

export interface UsernamePasswordCredentialsBaseDto extends CredentialBaseDto {
    username: string | null;
    password: string | null;
}

export interface BasicCredentialsDto extends UsernamePasswordCredentialsBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
}

export interface BearerCredentialsDto extends CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    clientId: string | null;
    clientSecret: string | null;
    grantType: string | null;
    username: string | null;
    password: string | null;
    additionalFields: { [key: string]: string; } | null;
    contentType: string | null;
    encodeCredentialsToBase64: boolean;
}

export interface CanModifyDataDto {
    canModifyDataSource: boolean;
    canModifyCertificate: boolean;
    canModifyConnection: boolean;
}

export interface CertificateCredentialsDto extends CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    certificateId: string;
}

export interface CertificateDto {
    id: string;
    dataProviderId: string;
    name: string | null;
    fileName: string | null;
    dataProviderName: string | null;
    hasPassword: boolean;
    expirationDate: string;
}

export interface CertificateEntity extends BaseEntity {
    name: string | null;
    fileName: string | null;
    password: string | null;
    content: string | null;
    dataProviderId: string;
    expireNotificationDate: string | null;
    expireOn: string;
}

export enum CompareOperator {
    Equal = 0,
    Greater = 1,
    Less = 2,
    GreaterOrEqual = 3,
    LessOrEqual = 4,
    In = 5,
    NotIn = 6,
    IsEmpty = 7,
    IsNotEmpty = 8,
    IsNotEqual = 9,
    InLastMonths = 10,
}

export enum Condition {
    And = 0,
    Or = 1,
}

export interface ConnectionConfiguration {
    cacheResponse: boolean;
    cacheResponseDurationInMinutes: number | null;
    readonly useMemoryCache: boolean;
    cleanUpPeriodInDays: number;
}

export interface ConnectionConfigurationDto {
    cacheResponse: boolean;
    cacheResponseDurationInMinutes: number | null;
    cleanUpPeriodInDays: number;
}

export interface ConnectionDto {
    id: string;
    tenantId: string;
    tenantName: string | null;
    stage: Stage;
    dataProviderId: string;
    dataSourceId: string;
    credential: CredentialBaseDto | null;
    customHeaders: KeyValuePairOfStringAndString[] | null;
    configuration: ConnectionConfigurationDto | null;
    canEdit: boolean;
}

export interface ConnectionEntity extends BaseEntity {
    tenant: string;
    stage: Stage;
    dataProvider: string;
    datasource: string;
    customHeadersJson: string | null;
    customHeadersJsonEncrypted: string | null;
    credentialsJson: string | null;
    credentialsJsonEncrypted: string | null;
    configurationJson: string | null;
}

export interface ConnectionListModel {
    id: string;
    stage: string | null;
    tenantId: string;
    tenantName: string | null;
    dataSourceVersion: string;
    configurationJson: string | null;
    readonly configuration: ConnectionConfiguration | null;
    canEdit: boolean;
}

export interface CookieCredentialsDto extends CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    credentials: { [key: string]: string; } | null;
}

export interface CreateUpdateCertificateDto {
    id: string;
    name: string | null;
    fileName: string | null;
    dataProviderId: string;
    password: string | null;
    contentBase64: string | null;
}

export interface CredentialItemDto {
    key: string | null;
    value: string | null;
}

export interface CustomTokenCredentialsDto extends UsernamePasswordCredentialsBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    headerName: string | null;
    tokenHeaders: KeyValuePairOfStringAndString[] | null;
    additionalFields: { [key: string]: string; } | null;
    expiresIn: number | null;
    tokenHttpMethod: HttpVerb;
}

export interface DataHubResult {
    readonly expressions: { [key: string]: any; } | null;
    readonly storageReference: string | null;
    isCachedResponse: boolean;
    readonly rawResponse: string | null;
    readonly responseType: string | null;
    errorResponse: string | null;
    readonly success: boolean;
}

export interface DataProviderDataSourcesDto {
    id: string;
    name: string | null;
    description: string | null;
    dataSources: DataSourceProviderDto[] | null;
}

export interface DataProviderDomain {
    name: string | null;
    description: string | null;
    links: DataProviderLink[];
    id: string;
    readonly isNew: boolean;
}

export interface EntityDto {
    id: string;
}

export interface DataProviderDto extends EntityDto {
    name: string | null;
    description: string | null;
    links: DataProviderLinkDto[] | null;
}

export interface DataProviderEntity extends BaseEntity {
    name: string | null;
    description: string | null;
    linksJson: string | null;
}

export interface DataProviderExportDto extends EntityDto {
    name: string | null;
    description: string | null;
    links: DataProviderLinkExportDto[];
}

export interface DataProviderLink {
    uri: string | null;
    label: string | null;
}

export interface DataProviderLinkDto {
    uri: string | null;
    label: string | null;
}

export interface DataProviderLinkExportDto {
    uri: string | null;
    label: string | null;
}

export interface DataServiceSettingsDto {
    name: string | null;
    searchFields: SearchFieldDto[] | null;
}

export interface DataSourceAsyncOptionsDto {
    interval: number;
    timeout: number;
}

export interface DataSourceConfigurationDto {
    authenticationMethod: AuthenticationMethod;
    signingMethod: SigningMethod;
    httpVerb: HttpVerb;
    responseType: ResponseType;
    contentType: string | null;
    stages: DataSourceStageDto[] | null;
    params: DataSourceParamsDto[] | null;
    retry: DataSourceRetryDto | null;
    asyncOptions: DataSourceAsyncOptionsDto | null;
    stripNullOrEmptyParametersFromJsonRequestBody: boolean;
    dataServiceSettings: DataServiceSettingsDto | null;
}

export interface VersionedEntityDto extends EntityDto {
    correlationId: string;
    createdDate: string;
    createdBy: string | null;
}

export interface DataSourceDto extends VersionedEntityDto {
    name: string | null;
    description: string | null;
    queryString: string | null;
    requestBody: string | null;
    configuration: DataSourceConfigurationDto | null;
    dataProvider: DataProviderDto | null;
}

export interface VersionedEntity extends BaseEntity {
    correlationId: string;
    createdDate: string;
    createdBy: string | null;
    importedBy: string | null;
    importedDate: string | null;
}

export interface DataSourceEntity extends VersionedEntity {
    name: string | null;
    description: string | null;
    queryString: string | null;
    requestBody: string | null;
    configurationJson: string | null;
    dataProviderId: string;
    dataProvider: DataProviderEntity | null;
}

export interface DataSourceExportDto extends VersionedEntityDto {
    name: string | null;
    description: string | null;
    queryString: string | null;
    requestBody: string | null;
    configuration: DataSourceConfigurationDto;
    expressions: ExpressionExportDto[];
}

export interface DataSourceListModel {
    id: string;
    name: string | null;
    createdDate: string;
    createdBy: string | null;
    description: string | null;
    correlationId: string;
    responseType: ResponseType;
    importedBy: string | null;
    importedDate: string | null;
}

export interface DataSourceParamsDto {
    name: string | null;
    isRequired: boolean;
    ignoreForCaching: boolean;
    /** When this is true, the expected value in the Data is a serialized JSON array. */
    isJsonArray: boolean;
}

export interface DataSourceProviderDto {
    id: string;
    name: string | null;
    description: string | null;
    connectionId: string;
}

export interface DataSourceProxyDto {
    isEnabled: boolean;
    server: string | null;
    port: number;
}

export interface DataSourceResponseDomain {
    name: string | null;
    response: string | null;
    dataSourceId: string;
    id: string;
    readonly isNew: boolean;
}

export interface DataSourceResponseEntity extends BaseEntity {
    dataSourceId: string;
    dataSource: DataSourceEntity | null;
    name: string | null;
    response: string | null;
}

export interface DataSourceRetryDto {
    interval: number;
    timeout: number;
}

export interface DataSourceStageDto {
    stage: Stage;
    readonly name: string | null;
    dataSourceUri: string | null;
    tokenUri: string | null;
    proxy: DataSourceProxyDto | null;
}

export interface DefaultCredentialsDto extends CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
}

export interface ExportDataSourcesDto {
    dataProvider: DataProviderExportDto;
    dataSources: DataSourceExportDto[];
    exportedOn: string;
    checksum: string;
}

export interface ExpressionDomain {
    name: string | null;
    dataSourceCorrelationId: string;
    query: Query | null;
    correlationId: string;
    createdDate: string;
    createdBy: string | null;
    importedDate: string | null;
    importedBy: string | null;
    id: ExpressionId;
}

export interface ExpressionEntity extends VersionedEntity {
    name: string | null;
    expressionJson: string | null;
    dataSourceCorrelationId: string;
}

export interface ExpressionExportDto {
    id: string;
    correlationId: string;
    name: string | null;
    createdBy: string | null;
    createdDate: string;
    queryJson: string | null;
}

export interface ExpressionId {
    value: string;
}

export interface ExpressionListModel {
    id: string;
    correlationId: string;
    name: string | null;
    createdDate: string;
    createdBy: string | null;
    dataSourceCorrelationId: string;
    importedBy: string | null;
    importedDate: string | null;
}

export interface ExpressionsResult {
    readonly results: QueryExecutionResult[] | null;
    readonly isValid: boolean;
}

export enum FieldType {
    StringType = 0,
    DecimalType = 1,
    BooleanType = 2,
    DatetimeType = 3,
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export enum HttpVerb {
    Post = 0,
    Get = 1,
    Put = 2,
    Delete = 3,
}

export interface InfoLogCredentialsDto extends CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    clientId: string | null;
    clientSecret: string | null;
    username: string | null;
}

export interface InvocationDetail {
    request: string | null;
    rawResponse: string | null;
    responseType: ResponseType;
}

export interface InvokeDataSourceModel {
    data: { [key: string]: string; } | null;
    configuration: { [key: string]: any; } | null;
    expressions: string[] | null;
}

export interface KeyValuePairOfStringAndString {
    key: string | null;
    value: string | null;
}

export interface MsalCredentialsDto extends CredentialBaseDto {
    readonly authenticationMethod: AuthenticationMethod;
    certificateId: string;
    clientId: string | null;
    authority: string | null;
}

export interface OrderBy {
    elementName: string | null;
    descending: boolean;
}

export interface QueryExecutionResult {
    readonly isValid: boolean;
    readonly key: string | null;
    readonly value: any | null;
}

export enum ResponseType {
    Json = 0,
    Xml = 1,
    Base64 = 2,
    Raw = 3,
}

export interface SearchFieldDto {
    path: string | null;
    query: string | null;
    fuzzyMatch: boolean;
    threshold: string | null;
    matchType: string | null;
}

export enum SelectMethod {
    All = 0,
    First = 1,
    Last = 2,
}

export enum SigningMethod {
    None = 0,
    SoapMessage = 1,
}

export enum Stage {
    TEST = 0,
    PRD = 1,
    DEV = 2,
    SPA = 3,
    ACC = 4,
}

export interface TenantDto {
    tenantId: string;
    tenantName: string | null;
}

export interface Field {
    path: string | null;
    label: string | null;
}

export interface Aggregation extends Field {
    aggregationMethod: AggregationMethod;
    isPiiData: boolean;
    wheres: Where[] | null;
}

export interface From {
    selectMethod: SelectMethod;
    path: string | null;
    wheres: Where[] | null;
}

export interface Query {
    aggregations: Aggregation[] | null;
    froms: From[] | null;
    select: SelectField | null;
    take: number;
    orderBy: OrderBy | null;
    readonly outputs: string[] | null;
}

export interface SelectField {
    label: string | null;
    fields: Field[] | null;
}

export interface Where {
    condition: Condition;
    path: string | null;
    type: FieldType;
    operator: CompareOperator;
    value: string | null;
    dateFormat: string | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}